"use client";

import type { ComponentType, SVGProps } from "react";
import AudioLinesSvg from "../../assets/animations/audio-lines.animated.svg";
import ClearSvg from "../../assets/animations/clear.animated.svg";
import FocusSvg from "../../assets/animations/focus.animated.svg";
import SearchSvg from "../../assets/animations/search.animated.svg";
import ThinkingSvg from "../../assets/animations/thinking.animated.svg";
import ToolCaseSvg from "../../assets/animations/tool-case.animated.svg";
import { AudioLinesAnimation } from "./audio-lines-animation";
import { ClearAnimation } from "./clear-animation";
import { FocusAnimation } from "./focus-animation";
import { SearchAnimation } from "./search-animation";
import { ThinkingAnimation } from "./thinking-animation";
import { ToolCaseAnimation } from "./tool-case-animation";

function stillIcon(Svg: ComponentType<SVGProps<SVGSVGElement>>) {
  return function StillIcon(props: SVGProps<SVGSVGElement>) {
    return <Svg focusable="false" height={24} width={24} {...props} data-svg-static="true" />;
  };
}

export const STILL_ANIMATION_ICONS = {
  clear: stillIcon(ClearSvg),
  focus: stillIcon(FocusSvg),
  "web-search": stillIcon(SearchSvg),
  thinking: stillIcon(ThinkingSvg),
  "tool-case": stillIcon(ToolCaseSvg),
  "audio-lines": stillIcon(AudioLinesSvg),
};

export const ANIMATED_ICONS = {
  clear: ClearAnimation,
  focus: FocusAnimation,
  "web-search": SearchAnimation,
  thinking: ThinkingAnimation,
  "tool-case": ToolCaseAnimation,
  "audio-lines": AudioLinesAnimation,
};

export type AnimatedIconName = keyof typeof ANIMATED_ICONS;
